import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import swal2 from 'sweetalert2'
import MaskedInput from "react-text-mask";

class CustomersCampaigns extends React.Component {
    constructor(props) {
        super(props);
        this.getCampaignDetails = this.getCampaignDetails.bind(this);
        this.showModalTermsTA = this.showModalTermsTA.bind(this);
        this.state = {
            token: {},
            campaign: {},
            promos: [],
            internalIP: "",
            redeemed: [],
            exclusive: null,
            flag: false
        };
    }

    componentWillMount() {
        let self = this;
    }

    componentDidMount()
    {
        let self = this;

        self.getCampaignDetails();

        //this.interval = setInterval(() => self.getCampaignDetails(), 5000);

        /*
        let ua = window.navigator.userAgent;
        let msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            console.log("IE");
        } else {
        */
            window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;//compatibility for Firefox and chrome
            let pc = new RTCPeerConnection({iceServers: []}), noop = function () {
            };
            pc.createDataChannel('');
            pc.createOffer(pc.setLocalDescription.bind(pc), noop);
            pc.onicecandidate = function (ice) {
                if (ice && ice.candidate && ice.candidate.candidate) {
                    let myIP = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
                    self.setState({
                        internalIP: myIP
                    });
                    pc.onicecandidate = noop;
                }
            };
        //}


    }

    getCampaignDetails()
    {
        let self = this;

        axios.get(location.origin + '/api/customers/campaigns/' + self.props.token)
            .then(response => {
                self.setState({
                    campaign: response.data.campaign,
                    promos: response.data.promos,
                    redeemed: response.data.redeemed,
                    exclusive: response.data.exclusive
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "Ha ocurrido un error al procesar tu solicitud.",
                    icon: "warning",
                });
            });
    }

    openTerms(item)
    {
        let win = window.open(item.terms, '_blank');
        win.focus();
    }

    showModalTermsTA() {
        swal2({
            imageUrl: '/img/headerAlert.png',
            imageClass: 'img-responsive',
            html:
                '<h4 class="sivale-swal2-title">Términos y condiciones Tiempo Aire</h4>'+
                '<p>' +
                '1. Si el cliente elige esta opción de canje tendrá que proporcionar al sistema vía web su compañía telefónica celular y los 10 dígitos de su número celular.\n' +
                '<br/>2. Al enviar esta información recibirá la confirmación de bonificación por mail en un plazo máximo de 10 minutos.\n' +
                '<br/>3. Algunas compañías como Telcel notifican vía sms la bonificación de Saldo.\n' +
                '<br/>4. En el caso de que la compañía no notifique al cliente la bonificación de el saldo el podrá corroborar la bonificación marcando al número especial de su compañía asignado para este propósito.\n' +
                '<br/>5. No aplica para números telefónicos que tengan asignado algún plan de prepago.' +
                '</p>',
            showCancelButton: false,
            showConfirmButton: false,
            closeOnClickOutside: false,
        });
    }

    renderPromos(item)
    {
        let self = this;

        let redeemed = self.state.redeemed.indexOf(item.id);

        let imgStyle = {
            width: "200px",
            maxHeight: "300px",
            maxWidth: "300px",
        };

        let desclubStyle = {
            width: "200px",
            maxHeight: "300px",
            maxWidth: "300px",
            backgroundColor: "#FFFFFF",
            color: "#FFA000 !important"
        };

        let helper = {
            display: "inline-block",
            height: "100%",
            verticalAlign: "middle",
        };

        let exclusive = self.state.exclusive;

        /*                            {
                                (item.available === true && item.restantes !== 0) &&
                                <p style={{ fontWeight: "normal" }}>¡{item.restantes} persona(s) han pedido esta promoción!</p>
                            }*/

        return(
            <div className="col-md-10 col-lg-6" key={item.id} >
                <article className="post-minimal">
                    <div className="post-left text-center">
                        <img src={item.url_image} className="img-responsive text-center" style={imgStyle}/>
                        {
                            parseInt(item.type) === 2 &&
                            <div className="pricing-table-label" style={desclubStyle}>
                                <h5 style={{ color: "#FFA000" }}>Promoción Exclusiva</h5>
                            </div>
                        }
                        {
                            parseInt(item.type) !== 2 &&
                            <div className="pricing-table-label" style={{ background: "#FFFFFF" }}>
                                <h5 style={{ color: "#000000" }}></h5>
                            </div>
                        }
                    </div>
                    <div className="post-body">
                        <div className="post-meta">
                            <h4 style={{ fontWeight: "normal" }}>{item.description}</h4>
                            {
                                (item.terms !== null) &&
                                <small>
                                    <a href={item.terms} target="_blank">
                                        Consultar términos y condiciones
                                    </a>
                                </small>
                            }
                            {
                                (item.terms === null && item.name === "Tiempo Aire") &&
                                <small>
                                    <a href={"javascript:void(0)"} onClick={this.showModalTermsTA}>
                                        Consultar términos y condiciones
                                    </a>
                                </small>
                            }
                        </div>
                        <br/>
                        <div className="post-footer text-center">
                            {
                                (parseInt(item.type) === 2 && exclusive === 0 && item.available !== false) &&
                                <button className="button btn-promo" onClick={this.checkUserAccess.bind(this, self.props.token, item.id)}
                                        style={{ borderRadius: "35px", backgroundColor: "#268EBF", color: "#FFFFFF" }}>
                                    <h5 style={{ color: "#FFFFFF", textTransform: "uppercase" }}>¡La quiero!</h5>
                                </button>
                            }
                            {
                                (parseInt(item.type) === 2 && exclusive !== 0  && redeemed === -1 && item.available !== false) &&
                                <button className="button btn-promo" onClick={this.showNoMoreExclusive.bind(this)}
                                        style={{ borderRadius: "35px", backgroundColor: "#268EBF", color: "#FFFFFF" }}>
                                    <h5 style={{ color: "#FFFFFF", textTransform: "uppercase" }}>¡Promoción no disponible!</h5>
                                </button>
                            }
                            {
                                (parseInt(item.type) === 2 && exclusive !== 0 && redeemed !== -1 && item.available !== false) &&
                                <button className="button btn-promo" onClick={this.showRedeemed.bind(this)}
                                style={{ borderRadius: "35px", backgroundColor: "#268EBF", color: "#FFFFFF" }}>
                                <h5 style={{ color: "#FFFFFF", textTransform: "uppercase" }}>¡Promoción solicitada!</h5>
                                </button>
                            }
                            {
                                (parseInt(item.type) !== 2 && redeemed === -1 && item.available === true && item.available !== false) &&
                                <button className="button btn-promo" onClick={this.checkUserAccess.bind(this, self.props.token, item.id)}
                                        style={{ borderRadius: "35px", backgroundColor: "#268EBF", color: "#FFFFFF" }}>
                                    <h5 style={{ color: "#FFFFFF", textTransform: "uppercase" }}>¡La quiero!</h5>
                                </button>
                            }
                            {
                                (parseInt(item.type) !== 2 && redeemed !== -1 && item.available !== false && item.available !== false) &&
                                <button className="button btn-promo" onClick={this.showRedeemed.bind(this)}
                                        style={{ borderRadius: "35px", backgroundColor: "#268EBF", color: "#FFFFFF" }}>
                                    <h5 style={{ color: "#FFFFFF", textTransform: "uppercase" }}>¡Promoción solicitada!</h5>
                                </button>
                            }
                            {
                                item.available === false &&
                                <button className="button btn-promo" onClick={this.showUnavailable.bind(this)}
                                style={{ borderRadius: "35px", backgroundColor: "#268EBF", color: "#FFFFFF" }}>
                                <h5 style={{ color: "#FFFFFF", textTransform: "uppercase" }}>¡Promoción agotada!</h5>
                                </button>
                            }
                            <br/>
                            <p className="text-center">Cupones disponibles: {item.redimidos}</p>
                        </div>
                    </div>
                </article>
            </div>
        );
    }

    showRedeemed()
    {
        /*'<br>'+
        '<p class="sivale-swal2-content">¡Te esperamos el próximo mes!</p>' +
        */
        swal2({
            imageUrl: '/img/headerAlert.png',
            imageClass: 'img-responsive',
            html:
                '<h4 class="sivale-swal2-title">¡Ya solicitaste tu promoción!</h4>'+
                '<p class="sivale-swal2-content">' +
                    'Recuerda que solo puedes pedir una promoción mensual. No olvides solicitar tu cupón Devlyn con ' +
                'valor de $500 M.N. llamando al 01 (800) 704 6427' +
                '</p>'+
            '<img src="/img/devlinAlert.png" class="center-block sivale-swal2-img" alt=""><br/><br/> ¡Te esperamos el próximo mes!',
            showCancelButton: false,
            showConfirmButton: false,
        });

    }

    showUnavailable()
    {
        swal2({
            imageUrl: '/img/headerAlert.png',
            imageClass: 'img-responsive',
            html:
                '<h4 class="sivale-swal2-title">¡Promoción agotada!</h1>'+
                '<p class="sivale-swal2-content">' +
                'Consulta las demás promociones disponibles.<br/>' +
                'Recuerda que puedes solicitar tu cupón Devlyn con valor de $500 M.N. llamando al 01 (800) 704 6427.' +
                '</p>'+
                '<img src="/img/devlinAlert.png" class="center-block sivale-swal2-img" alt="">',
            showCancelButton: false,
            showConfirmButton: false,
            closeOnClickOutside: false,
        });
    }

    showNoMoreExclusive()
    {
        swal2({
            imageUrl: '/img/headerAlert.png',
            imageClass: 'img-responsive',
            html:
                '<h4 class="sivale-swal2-title">¡Promoción no disponible!</h1>'+
                '<p class="sivale-swal2-content">' +
                'Recuerda que solo puedes pedir una promoción mensual. No olvides solicitar tu cupón Devlyn con ' +
                'valor de $500 M.N. llamando al 01 (800) 704 6427' +
                '</p>'+
                '<img src="/img/devlinAlert.png" class="center-block sivale-swal2-img" alt="">',
            showCancelButton: false,
            showConfirmButton: false,
            closeOnClickOutside: false,
        });
    }

    checkUserAccess(token_uniqid, id_promo)
    {
        axios.get(location.origin + '/api/token/' + token_uniqid + '/' + id_promo)
            .then(response => {
                let token = response.data.token;
                let promo_key = response.data.promo_key;
                if (token !== null) {
                    window.location.href = '/' + token.token + '/promo/' + promo_key;
                }
            })
            .catch(error => {
                swal2({
                    imageUrl: '/img/headerAlert.png',
                    imageClass: 'img-responsive',
                    html:
                        '<h4 class="sivale-swal2-title">¡Ya solicitaste tu promoción!</h4>'+
                        '<p class="sivale-swal2-content">' +
                        'Recuerda que solo puedes pedir una promoción mensual. No olvides solicitar tu cupón Devlyn con ' +
                        'valor de $500 M.N. llamando al 01 (800) 704 6427' +
                        '</p>'+
                        '<img src="/img/devlinAlert.png" class="center-block sivale-swal2-img" alt=""><br/><br/> ¡Te esperamos el próximo mes!',
                    showCancelButton: false,
                    showConfirmButton: false,
                });
            });
    }

    render()
    {
        let self = this;

        return (
            <div>
                <section className="sivale-promos-header">
                    <div className="col-xs-12 col-md-9 col-sm-8">
                        <h1 className="sivale-promos-header-title" style={{ color: "#FFFFFF !important" }}>
                            ¡Elige tu promoción del mes!
                        </h1>

                    </div>
                    <div className="col-md-3 col-sm-4 visible-lg visible-md"
                         style={{ paddingRight: "0 !important" }}>
                        <img className="bobPromos img-responsive" src="/images/beneficios-01.png" alt={""}/>
                    </div>
                </section>

                <section className="section-35 bg-whisper" style={{ marginTop: "0 !important" }}>
                    <div className="container text-center text-sm-left">
                        <div className="row row-30 eq-height">
                            {this.state.promos.map(this.renderPromos.bind(this))}
                        </div>
                        <div className="row row-30 text-center">
                            <h3>
                                Recuerda que puedes solicitar una promoción mensual, si ya lo hiciste,
                                <br/>¡Te esperamos el próximo mes!
                            </h3>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default CustomersCampaigns;

if (document.getElementById('customers_campaigns-component')) {
    ReactDOM.render(<CustomersCampaigns
        token={token}/>, document.getElementById('customers_campaigns-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/CustomersCampaigns.jsx